import HookLoader from './HookLoader/HookLoader';
import useToken from './useToken';

const win: any = window;
const baseUrl = window.location.origin.includes('localhost') ? "http://ssta004:8080" : window.location.origin;

interface BMProps {
  setBMToken: React.Dispatch<React.SetStateAction<boolean>>;
}

const BMToken = ({ setBMToken }: BMProps) => {
  const url = `${baseUrl}/mobilyTheme4/BzFvwmzXvs`;
  const req = { "dataT": "bm" }
  const { response, loading } = useToken(url, req, setBMToken);

  if (response) {
    !!!win["bmToken"] && (win["bmToken"] = response);
  }

  return (
    <>
      {loading && <HookLoader loading={loading} />}
    </>
  )
}

export { BMToken }